 import RSVPButton from './RSVP/button';
import logo from '../logo.png';

 const NavContainer = ({ menuOpen, setMenuOpen, scrollToSection, showRSVPOnMenu, setRSVP }) => (
  <div className="navContainer">
  <img
    className="logo"
    src={logo}
    style={{ maxWidth: "150px", left: "-50px", height: "auto" , top: "-30px"}}
  />

  {/* Hamburger (mobile only) */}
  <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
    <span />
    <span />
    <span />
  </div>

  {/* Nav */}
  <div className={`nav ${menuOpen ? "open" : ""}`}>
    <p style={{ fontFamily: "PP Neue Montreal", letterSpacing: "0.2em" }} onClick={() => {scrollToSection("story"); setMenuOpen(false)}}>Our Story</p>
    <p style={{ fontFamily: "PP Neue Montreal", letterSpacing: "0.2em" }} onClick={() => {scrollToSection("travel"); setMenuOpen(false)}}>Travel & Stay</p>
    <p style={{ fontFamily: "PP Neue Montreal", letterSpacing: "0.2em" }} onClick={() => {scrollToSection("details"); setMenuOpen(false)}}>Wedding Details</p>
    <p style={{ fontFamily: "PP Neue Montreal", letterSpacing: "0.2em" }} onClick={() => {scrollToSection("itinerary"); setMenuOpen(false)}}>Itinerary</p>

    {showRSVPOnMenu && (
      <p style={{ marginRight: "1rem" }}>
        <RSVPButton onClick={setRSVP} />
      </p>
    )}
  </div>
</div>)
export default NavContainer;